import { render, staticRenderFns } from "./UserInformationModal.vue?vue&type=template&id=26a1361f&"
import script from "./UserInformationModal.vue?vue&type=script&lang=js&"
export * from "./UserInformationModal.vue?vue&type=script&lang=js&"
import style0 from "./UserInformationModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports